import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ssp-map-locate-user-button',
  templateUrl: './map-locate-user-button.component.html',
  styleUrls: ['./map-locate-user-button.component.scss', '../../../../../../../../../assets/soti-tooltip.scss'],
})
export class MapLocateUserButton {
  @Input()
  locateUserInProgress = false;

  @Output()
  locateUser = new EventEmitter<null>();

  locateDeviceFn() {
    this.locateUser.emit(null);
  }
}
